import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import NotFoundContainerQuery, {
	type NotFoundContainerQuery$data,
	type NotFoundContainerQuery$variables,
} from './__generated__/NotFoundContainerQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export const preloadDraftRedirect = ({
	contentId,
	draftShareId,
}: {
	contentId: string;
	draftShareId: string;
}): Promise<{
	data: NotFoundContainerQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> => {
	return query<NotFoundContainerQuery$data, NotFoundContainerQuery$variables>({
		query: NotFoundContainerQuery,
		variables: { contentId, draftShareId, status: ['draft'] },
	});
};
